// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_f7-6";
export var emphasizeQuantity = "_f7-3";
export var flatBottomCorners = "_f7-5";
export var productImage = "_f7-0";
export var quantityContainer = "_f7-2";
export var tooltip = "_f7-1";
export var wrapAndEllipsesOverflow = "_f7-4";